module.exports = __webpack_public_path__ + "static/media/creative-logo1.7921eb0a.png";